import { useRoutes, Navigate } from 'react-router-dom'
import Document from 'view/document'
import Extension from 'view/extension'
import ExtensionCollect from 'view/extension/collect'
import Index from 'view/index'
import Home from 'view/home'
import Coll from 'view/home/coll'
import IntellectRecommend from 'view/home/intellectRecommend'
import AllStyle from 'view/home/allStyle'
import Detail from 'view/detail'
import Inspiration from 'view/home/inspiration'
import ExclusiveDetail from 'view/home/exclusiveDetail' // 专属推荐
import { DetailContent as ImageDetail } from 'view/detail/imageDetail'
import IntelligentDetail from 'view/home/intelligentClassification/intelligent'
import TagDetail from 'view/home/intelligentClassification/tag'
import Analysis from 'view/home/analysis'
import ChooseAnalysis from 'view/home/analysis/chooseAnalysis'
import RepeatCollect from 'view/home/analysis/repeatCollect'
import Recycle from 'view/home/recycle'
import VersionsControl from 'view/home/versionsControl'
import EditProcess from 'component/imageDetail/editProcess'
import ReceivePage from 'view/detail/receive'

import Workbench from 'view/home/workbench'
import Marking from 'view/home/marking'

import CategoryTags from 'view/home/intelligentClassification/categoryTags'

import NoviceRecommendation from 'view/noviceRecommendation'
import NoviceRecommendation1 from 'view/noviceRecommendation/phase1'
import NoviceRecommendation2 from 'view/noviceRecommendation/phase2'

// 样衣相关
import SampleLayout from 'view/home/sample/layout'
import SampleHome from 'view/home/sample/index'
import SampleFolder from 'view/home/sample/folderDetail'
import SampleDetail from 'view/detail/sample'

import ErrorBoundary from './view/errorBoundary'

export default function Router() {
  if (!localStorage.getItem('mn-homePage')) {
    localStorage.setItem('mn-homePage', 1)
  }
  const homePageLink = +localStorage.getItem('mn-homePage') ? '/home/workbench/index' : '/home/coll'
  const element = useRoutes([
    {
      path: '/',
      element: <Index />,
      children: [
        { index: true, element: <Navigate to="/home" /> },
        {
          path: '/home',
          element: <Home />,
          children: [
            { index: true, element: <Navigate to={homePageLink} /> },
            {
              path: '/home/workbench',
              children: [
                { index: true, element: <Navigate to="/home/workbench/index" /> },
                { path: '/home/workbench/index', element: <Workbench /> },
                { path: '/home/workbench/marking', element: <Marking /> },
              ] },
            { path: '/home/category-tags', element: <CategoryTags /> },
            {
              path: '/home/coll',
              children: [
                { index: true, element: <Navigate to="/home/coll/index" /> },
                { path: '/home/coll/index', element: <Coll /> },
                { path: '/home/coll/detail/:id', element: <Inspiration /> },
                { path: '/home/coll/exclusive-detail', element: <ExclusiveDetail /> },
              ]
            },
            { path: '/home/all', element: <AllStyle /> },
            {
              path: '/home/sample',
              element: <SampleLayout />,
              loader: () => ({ customHeader: true }),
              children: [
                { index: true, element: <SampleHome />, },
                {
                  path: '/home/sample/:folderId', element: <SampleFolder />,
                }
              ]
            },
            { path: '/home/intellectRecommend', element: <IntellectRecommend /> }, // 智能选款
            { path: '/home/intelligent/detail', element: <IntelligentDetail /> },
            { path: '/home/tag/detail', element: <TagDetail /> },
            {
              path: '/home/analysis',
              element: <Analysis />,
              children: [
                { index: true, element: <Navigate to="/home/analysis/choose" /> },
                { path: '/home/analysis/choose', element: <ChooseAnalysis /> },
                { path: '/home/analysis/repeatCollect', element: <RepeatCollect /> },
              ]
            },
            { path: '/home/recycle', element: <Recycle /> },
            { path: '/home/version', element: <VersionsControl /> },
          ]
        },
        {
          path: '/detail',
          element: <Detail />,
          children: [
            { path: '/detail/sample/image', element: <SampleDetail /> },
            { path: '/detail/image', element: <ImageDetail /> },
          ]
        },
        { path: '/document', element: <Document /> },
        { path: '/extension',
          element: <Extension />,
          children: [
            { path: 'collect', element: <ExtensionCollect /> }
          ] },
        {
          path: '/editProcess',
          element: <EditProcess />
        },
        {
          path: '/receive',
          element: <ReceivePage />,
        },
        {
          path: '/noviceRecommendation',
          element: <NoviceRecommendation />
        },
        {
          path: '/noviceRecommendation1',
          element: <NoviceRecommendation1 />
        },
        {
          path: '/noviceRecommendation2',
          element: <NoviceRecommendation2 />
        },
        {
          path: '*',
          element: <ErrorBoundary />
        },
      ],
    }
  ])
  return element
}
